import React from 'react';

import svg from './assets/icons-36-facebook.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconFacebook = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-facebook" />
);
